<template>
  <div class="form-group d-flex align-items-center">
    
    <input
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      v-bind:value="value"
      type="color"
      class=""
      :id="name"
    />
    <input
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      v-bind:value="value"
      type="text"
      class="ml-2 form-control"
      :id="name"
    />
    <!-- <div class="ml-2"><code style="text-transform:uppercase;">{{ value }}</code></div> -->
  </div>
</template>

<script>
export default {
  name: "Color",
  inheritAttrs: false,
  props: {
    label: String,
    name: String,
    value: [String, Boolean, Array, Object, Number],
  },
  data() {
    return {
      color: "",
    };
  },
};
</script>

<style>
code{
  color: #1F2937;
}
input[type="color"] {
	-webkit-appearance: none;
	border-color: transparent;
	width: 50px;
	height: 24px;
  border-radius: 4px;
}
input[type="color"]::-webkit-color-swatch-wrapper {
	padding: 0;
  
}
input[type="color"]::-webkit-color-swatch {
	border: none;
  border-radius: 4px;
}
</style>